import { render } from "./ReceiptDownloadLinks.vue?vue&type=template&id=db2d4c4a"
import script from "./ReceiptDownloadLinks.vue?vue&type=script&lang=js"
export * from "./ReceiptDownloadLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__